"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  v: '5.7.3',
  fr: 60,
  ip: 0,
  op: 60,
  w: 300,
  h: 300,
  nm: 'Dot_Loading',
  ddd: 0,
  assets: [],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: 'center',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.4,
            y: 1
          },
          o: {
            x: 0.6,
            y: 0
          },
          t: 10,
          s: [144, 144, 0],
          to: [0, -3.333, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.4,
            y: 1
          },
          o: {
            x: 0.6,
            y: 0
          },
          t: 22,
          s: [144, 124, 0],
          to: [0, 0, 0],
          ti: [0, -3.333, 0]
        }, {
          t: 34,
          s: [144, 144, 0]
        }],
        ix: 2
      },
      a: {
        a: 0,
        k: [12.5, 6, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [764.558, 764.558, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, -0.828], [0.828, 0], [0, 0.828], [-0.828, 0]],
            o: [[0, 0.828], [-0.828, 0], [0, -0.828], [0.828, 0]],
            v: [[1.5, 0], [0, 1.5], [-1.5, 0], [0, -1.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.6470588235294118, 0.6705882352941176, 0.7568627450980392, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fond 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [17.667, 5.833],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Groupe 1',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 76,
    st: -62,
    bm: 0
  }, {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: 'right',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.4,
            y: 1
          },
          o: {
            x: 0.6,
            y: 0
          },
          t: 5,
          s: [144, 144, 0],
          to: [0, -3.333, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.4,
            y: 1
          },
          o: {
            x: 0.6,
            y: 0
          },
          t: 17,
          s: [144, 124, 0],
          to: [0, 0, 0],
          ti: [0, -3.333, 0]
        }, {
          t: 29,
          s: [144, 144, 0]
        }],
        ix: 2
      },
      a: {
        a: 0,
        k: [12.5, 6, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [764.558, 764.558, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, -0.828], [0.828, 0], [0, 0.828], [-0.828, 0]],
            o: [[0, 0.828], [-0.828, 0], [0, -0.828], [0.828, 0]],
            v: [[1.5, 0], [0, 1.5], [-1.5, 0], [0, -1.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.6470588235294118, 0.6705882352941176, 0.7568627450980392, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fond 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [12.333, 5.833],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Groupe 2',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 76,
    st: -62,
    bm: 0
  }, {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: 'left',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.4,
            y: 1
          },
          o: {
            x: 0.6,
            y: 0
          },
          t: 0,
          s: [144, 144, 0],
          to: [0, -3.333, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.4,
            y: 1
          },
          o: {
            x: 0.6,
            y: 0
          },
          t: 12,
          s: [144, 124, 0],
          to: [0, 0, 0],
          ti: [0, -3.333, 0]
        }, {
          t: 24,
          s: [144, 144, 0]
        }],
        ix: 2
      },
      a: {
        a: 0,
        k: [12.5, 6, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [764.558, 764.558, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, -0.828], [0.828, 0], [0, 0.828], [-0.828, 0]],
            o: [[0, 0.828], [-0.828, 0], [0, -0.828], [0.828, 0]],
            v: [[1.5, 0], [0, 1.5], [-1.5, 0], [0, -1.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.6470588235294118, 0.6705882352941176, 0.7568627450980392, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fond 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [7, 5.833],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Groupe 3',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 76,
    st: -62,
    bm: 0
  }],
  markers: []
};
exports["default"] = _default;